import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    padding: "16px",
    gap: 16,
    direction: theme.direction === "ltr" ? "ltr" : "rtl",
  },
  mobile_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
    padding: "16px",
    gap: 16,
    flexDirection: "column",
    direction: theme.direction === "ltr" ? "ltr" : "rtl",
  },
}));

export default useStyles;
